import { render } from "./StocksScreen.vue?vue&type=template&id=7ebdfa3e&scoped=true"
import script from "./StocksScreen.vue?vue&type=script&lang=js"
export * from "./StocksScreen.vue?vue&type=script&lang=js"

import "./StocksScreen.vue?vue&type=style&index=0&id=7ebdfa3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebdfa3e"]])

export default __exports__